import { Button, Flex, Text } from '@chakra-ui/react'

interface ICoursesLoadErrorProps {
  onRetry: () => void
  isDisabled?: boolean
}

/**
 * Shown under the course select when its list failed to load, so the failure does not
 * read as "no course found" and the user can retry without switching modality.
 */
export default function CoursesLoadError({ onRetry, isDisabled }: ICoursesLoadErrorProps) {
  return (
    <Flex align="center" gap={3} wrap="wrap" mt={2}>
      <Text fontSize="sm" color="red.500">
        Não foi possível carregar os cursos.
      </Text>
      <Button size="sm" variant="outline" onClick={onRetry} isDisabled={isDisabled}>
        Tentar novamente
      </Button>
    </Flex>
  )
}
